// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".transport-accessibility2__map{position:absolute;overflow:hidden;top:0;left:0;width:100%;height:100%;filter:drop-shadow(0 4px 15px rgba(0,0,0,.1));border-radius:15px}.transport-accessibility2__map-mobile iframe,.transport-accessibility2__map>*{width:100%;height:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
